"use strict";Object.defineProperty(exports, "__esModule", {value: true});

var _chunkLIMHS54Rcjs = require('./chunk-LIMHS54R.cjs');


var _chunkLXPTESL6cjs = require('./chunk-LXPTESL6.cjs');

// src/contracts/farm/v3/index.ts
var FARM = {
  NftItem: _chunkLIMHS54Rcjs.FarmNftItemV3,
  NftMinter: _chunkLXPTESL6cjs.FarmNftMinterV3
};



exports.FARM = FARM;
//# sourceMappingURL=chunk-47DQFHHM.cjs.map